// Utility function to determine whether a given URL belongs to the current domain (local) or is external
export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links

export function openNewTab(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// ****************************************************************************************************************************************************
// Utility function to create custom burger toggle button

export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// ****************************************************************************************************************************************************
// Utility to update the header top on scroll

export function updateOnScroll(generalMessageHeight) {
  if ($('body').hasClass('saffireWindowScrolled')) {
    $('header').css('top', -generalMessageHeight + 'px');
  } else {
    $('header').css('top', '0');
  }
}

// ****************************************************************************************************************************************************
// Utility to adjust lineup button layout based on container width

export function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  if (!icons.children().length) {
    icons.remove();
  }
}
